

export const citationMixin = {
  data: function() {
    return {};
  },
  mounted: function() {
    // Logger.trace("globalMixin", global)
  },
  computed: {

  },
  methods: {
    citeSearch(citationType) {
      if(!citationType) {
        citationType = 'apa';
      }

      //National Center for Biotechnology Information (2023). PubChem Compound Summary for , SARS-CoV-2. Retrieved August 25, 2023 from https://pubchem.ncbi.nlm.nih.gov/compound/SARS-CoV-2.
      let current = "",
        citeString = "";

      if(citationType === 'ama') {
        current = moment().format('MMM. DD, YYYY');
        citeString = "Food Packaging Forum Foundation. Food Contact eXplorer food contact chemical catalog. " + window.location.href + ". Accessed " + current  + ".";
      } else if(citationType === 'mla') {
        current = moment().format('DD MMMM, YYYY');
        citeString = "Food Packaging Forum Foundation. \"Food Contact eXplorer food contact chemical catalog\" Food Contact explorer, "  + window.location.href + ". Accessed " + current + ".";
      } else {
        const citeYear = moment().year();
        current = moment().format('LL');
        citeString = "Food Packaging Forum Foundation (" + citeYear +"). Food Contact eXplorer food contact chemical catalog. Retrieved " + current + " from " + window.location.href + ".";
      }

      // Copy the text inside the text field
      navigator.clipboard.writeText(citeString);
      // Alert the copied text
      this.$notify({
        title: "Copied",
        message: "Citation copied to clipboard",
        type: "success",
        timeout: 3000,
        horizontalAlign: "right",
        verticalAlign: "top",
        icon: 'nc-icon nc-app',
      });

    },
    citeDetail(citationType) {
      if(!citationType) {
        citationType = 'apa';
      }

      //National Center for Biotechnology Information (2023). PubChem Compound Summary for , SARS-CoV-2. Retrieved August 25, 2023 from https://pubchem.ncbi.nlm.nih.gov/compound/SARS-CoV-2.
      let current = "",
        citeString = "";

      if(citationType === 'ama') {
        current = moment().format('MMM. DD, YYYY');
        citeString = "Food Packaging Forum Foundation. Food Contact eXplorer chemical profile for CAS " + this.CurrentMasterX.cas.id + ", " + this.CurrentMasterX.name + ". " + window.location.href + ". Accessed " + current  + ".";
      } else if(citationType === 'mla') {
        current = moment().format('DD MMMM, YYYY');
        citeString = "Food Packaging Forum Foundation. \"Food Contact eXplorer chemical profile for CAS " + this.CurrentMasterX.cas.id + ", " + this.CurrentMasterX.name + "\" Food Contact explorer, "  + window.location.href + ". Accessed " + current + ".";
      } else {
        const citeYear = moment().year();
        current = moment().format('LL');
        citeString = "Food Packaging Forum Foundation (" + citeYear +"). Food Contact eXplorer chemical profile for CAS " + this.CurrentMasterX.cas.id + ", " + this.CurrentMasterX.name + ". Retrieved " + current + " from " + window.location.href + ".";
      }

      // Copy the text inside the text field
      navigator.clipboard.writeText(citeString);
      // Alert the copied text
      this.$notify({
        title: "Copied",
        message: "Citation copied to clipboard",
        type: "success",
        timeout: 3000,
        horizontalAlign: "right",
        verticalAlign: "top",
        icon: 'nc-icon nc-app',
      });

    },
    downloadCitation(formatType) {
      Logger.debug("downloadCitation", formatType);
      if(!formatType) {
        formatType = "tsv";
      }

      const
        citeYear = moment().year(),
        exportHeaderLine = [
          "Reference Type",
          "Author",
          "Year",
          "Title",
          "URL"
        ],
        exportDataLine = [
          "Online Database",
          "Food Packaging Forum",
          citeYear,
          "Food Contact eXplorer chemical profile for CAS " + this.CurrentMasterX?.cas?.id + ", " + this.CurrentMasterX.name,
          window.location.href
        ];

      let exportData = "";

      if(formatType === "json") {
        let exportDataJSON = {};
        for(let i = 0, len = exportHeaderLine.length; i < len; i++) {
          exportDataJSON[exportHeaderLine[i]] = exportDataLine[i];
        }
        exportData = JSON.stringify(exportDataJSON);
      } else {
        let delimiter = "\t";
        if(formatType === "csv") {
          delimiter = ",";
          exportData = "sep=" + delimiter + "\n";
        }
        exportData += exportHeaderLine.join(delimiter) + "\n" + exportDataLine.join(delimiter);
      }
      this.download(exportData, "FCX-export-" + this.CurrentMasterX.slug + "." + formatType);
    },
    downloadJson() {
      Logger.debug("downloadJson");
      const masterDoc = JSON.stringify(this.CurrentMasterX);
      this.download(masterDoc, "FCX-export-full-" + this.CurrentMasterX.slug + ".json")
    },
    download(data, filename) {
      Logger.debug("download", data, filename);
      const blob = new Blob([data], { type: 'plain/text' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = filename;
      link.click()
      URL.revokeObjectURL(link.href)
    }
  }
};
